import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `Pedido/importarPedidosCuartesa`, method: 'POST', body: value, token: token})
}
